module.exports = __webpack_public_path__ + "static/media/atmos_randolf_mckinney.8126cd56.jpg";